import { render } from "./WorkAttachmentShowDialog.vue?vue&type=template&id=b05b2ff6&scoped=true"
import script from "./WorkAttachmentShowDialog.vue?vue&type=script&lang=js"
export * from "./WorkAttachmentShowDialog.vue?vue&type=script&lang=js"

import "./WorkAttachmentShowDialog.vue?vue&type=style&index=0&id=b05b2ff6&scoped=true&lang=css"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b05b2ff6"]])

export default __exports__